import { getGroupPermissionFactory, PermissionEnum } from '../../../common';
import { getFinancialManagementModuleName } from './financial-management.permissions';

export class InvoicesPermissions {
  static GroupName = `${getFinancialManagementModuleName()}.Invoices`;

  static getPermissions = getGroupPermissionFactory(InvoicesPermissions.GroupName);

  static Permissions = {
    Read: InvoicesPermissions.getPermissions(PermissionEnum.READ),
    ReadAll: InvoicesPermissions.getPermissions(PermissionEnum.READ_ALL)
  };
}
